import { faAlarmPlus } from '@fortawesome/pro-regular-svg-icons'
import { Alert, Box, Flex, Text } from '@mantine/core'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreItemPricingTier } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useTaxesInfo } from '../../../taxes'
import { SelectPricingTiers } from '../SelectPricingTiers/SelectPricingTiers'
import { useFormContext } from './FormBookingProduct'
import styles from './styles.module.css'

type FormSectionPriceRentalProps = {
  resetCustomValue: boolean
  open?: boolean
  resetPricingTier: VoidFunction
}
export function FormSectionPriceRental({
  resetCustomValue,
  open,
  resetPricingTier,
}: FormSectionPriceRentalProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })

  const { userSettingShowPricesWithTaxes } = useTaxesInfo()

  const form = useFormContext()

  const [alertOpen, setAlertOpen] = useState(true)

  const selectedPricingTier = form.values.pricing_tiers?.find(
    (item) => item.selected === true
  )
  return (
    <Box mt='lg'>
      <Flex direction='column' w='100%'>
        <Flex gap='sm'>
          <Text fw={500}>{t('label_price_tiers')}</Text>
        </Flex>

        <Text c='dimmed' size='sm'>
          {userSettingShowPricesWithTaxes
            ? t('description_price_tiers_incl_tax')
            : t('description_price_tiers')}
        </Text>
        <SelectPricingTiers
          open={open}
          searchable={false}
          pricingTiersItem={
            form.values.pricing_tiers as unknown as CoreItemPricingTier[]
          }
          onChangePricingTiers={(pricingTiers) => {
            form.setFieldValue('pricing_tier', pricingTiers)
          }}
          taxRate={form.values.tax_rate}
          taxable={form.values.taxable}
          resetCustomValue={resetCustomValue}
          resetPricingTier={resetPricingTier}
        />

        {selectedPricingTier?.type === 'dynamic' && alertOpen && (
          <Alert
            className={styles.alertCustom}
            title={<Text fw='500'>{t('label_alert_overtime')}</Text>}
            icon={<Icon icon={faAlarmPlus} />}
            color='blue'
            onClose={() => setAlertOpen(false)}
            withCloseButton
            mt='md'
          >
            <Text c='blue.7'>{t('description_alert_overtime')}</Text>
          </Alert>
        )}
      </Flex>
    </Box>
  )
}
